/**
 * Vike sometimes omits `urlPathname` for a frame during client-side navigation while
 * `window.location` already reflects the target URL. Layout code that falls back to
 * `window` for "is SRP?" must not treat that as a steady state for diagnostics or
 * merged data until page context matches the browser URL.
 */

export function normalizePathnameForLayoutCompare(pathname: string): string {
  return String(pathname).replace(/\/+$/, '') || '/';
}

export function resolveCommittedPathnameFromPageContext(
  pageContext: {
    urlPathname?: string;
    urlLogical?: string;
    urlParsed?: { pathname?: string };
  } | null | undefined,
): string | null {
  const raw =
    pageContext?.urlPathname ??
    pageContext?.urlLogical ??
    pageContext?.urlParsed?.pathname ??
    null;
  if (raw == null || raw === '') return null;
  return raw;
}

/** True on SSR, or on the client when Vike's pathname agrees with `window.location`. */
export function isLayoutClientRouteSyncedWithWindow(
  pageContext: {
    urlPathname?: string;
    urlLogical?: string;
    urlParsed?: { pathname?: string };
  } | null | undefined,
): boolean {
  if (typeof window === 'undefined') return true;
  const committed = resolveCommittedPathnameFromPageContext(pageContext);
  if (committed == null) return false;
  return (
    normalizePathnameForLayoutCompare(committed) ===
    normalizePathnameForLayoutCompare(window.location.pathname)
  );
}
